// extracted by mini-css-extract-plugin
export var close = "sidebar-popup-module--close--faa5e";
export var content = "sidebar-popup-module--content--50418";
export var popup = "sidebar-popup-module--popup--c4fe5";